<template>
  <v-dialog v-model="show" persistent max-width="420px">
    <v-card>
      <v-card-title primary-title>
        <div class="ml-1 headline">{{ $t('vmail.cfg.greeting.confirmTitle') }}</div>
      </v-card-title>
      <v-card-text>
        <div v-html="promptMessage"></div>
      </v-card-text>
      <v-card-text>
        <v-switch v-model="archive" :label="$t('vmail.cfg.greeting.archive.label')">
          <template v-slot:prepend>
            <cp-help i18n="vm.archive"/>
          </template>
        </v-switch>
        <v-text-field :label="$t('vmail.cfg.greeting.archive.name')" outlined
          :rules="[requiedName]"
          :disabled="!archive"
          v-model="archName"/>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
          <v-spacer />
          <v-btn @click="$emit('cancel')" text>
            {{ $t('vmail.cfg.greeting.btnCancel') }}
          </v-btn>
          <v-btn color="red" :disabled="!readyReset" text
            @click="$emit('confirm', archiveData)">
            <v-icon small class="mr-2">mdi-lock-reset</v-icon>
            {{ $t('vmail.cfg.greeting.btnReset') }}
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'vmail-greeting-confirm-reset',
  data () {
    return {
      archive: false,
      archName: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      defatul: false
    },
    icon: {
      type: String
    },
    name: {
      type: String
    }
  },
  computed: {
    promptMessage: function () {
      return this.$t('vmail.cfg.greeting.confirmMsg', { name: this.name })
    },
    archiveData: function () {
      return { archive: this.archive, archName: this.archName }
    },
    readyReset: function () {
      if (this.archive && this.archName.trim().length === 0) {
        return false
      }
      return true
    },
    requiedName: function (val) {
      return this.readyReset || this.$t('vmail.cfg.greeting.archive.nameRequired')
    }
  },
  watch: {
    show: function (val) {
      if (!val) {
        this.archive = false
        this.archName = ''
      }
    }
  }
}
</script>

<style scoped>
</style>
